import makeTypeCreator from '@/models/makeTypeCreator'

const createType = makeTypeCreator('banner')

export const SHOW_INFO_DIALOG = createType('SHOW_INFO_DIALOG')


